import { styled } from '@mui/material/styles';

const DatePickerWrapper = styled('div')(({ theme }) => ({
  // Targets the floating calendar container (the popup).
  '& .react-datepicker-popper': {
    zIndex: theme.zIndex.modal + 2, // Ensure it's clearly above modals
    '& .react-datepicker': {
      borderRadius: 0,
      border: 'none',
      boxShadow: theme.shadows[4],
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,

      // Hides the triangle pointer
      '& .react-datepicker__triangle': {
        display: 'none',
      },

      // --- B. Header/Navigation Styles ---

      '& .react-datepicker__header': {
        backgroundColor: theme.palette.common.white,
        border: 'none',
        borderRadius: 0,
        paddingTop: 15,

        // Month/Year title
        '& .react-datepicker__current-month': {
          fontSize: theme.typography.pxToRem(16), // Used pxToRem for consistency
          fontWeight: 500,
        },

        // Day names (Sun, Mon, etc.)
        '& .react-datepicker__day-names': {
          display: 'flex',
          marginTop: 10,
          justifyContent: 'center',
          '& .react-datepicker__day-name': {
            alignItems: 'center',
            color: theme.palette.text.secondary, // Use theme for gray color
            display: 'flex',
            height: 30,
            margin: 0,
            fontSize: theme.typography.pxToRem(12),
            justifyContent: 'center',
            width: 30,
          },
        },
      },

      // Navigation arrows wrapper
      '& .react-datepicker__navigation': {
        height: 8,
        width: 8,
      },

      // Previous month arrow
      '& .react-datepicker__navigation--previous': {
        border: 'solid #000',
        borderWidth: '0 2px 2px 0',
        left: 20,
        padding: 2,
        top: 18,
        transform: 'rotate(135deg)',
      },

      // Next month arrow (default)
      '& .react-datepicker__navigation--next': {
        border: 'solid #000',
        borderWidth: '0 2px 2px 0',
        right: 20, // Reset default right position
        padding: 2,
        top: 18,
        transform: 'rotate(-45deg)',
      },

      // Next month arrow when it has time picker
      '& .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button)':
        {
          // You can keep this override if you need a different position when time picker is present
          right: 130, // Example: shift it when time picker is visible
        },

      // --- C. Day/Month Grid Styles ---

      '& .react-datepicker__month-container': {
        '& .react-datepicker__week': {
          display: 'flex',
          '& .react-datepicker__day': {
            display: 'flex',
            alignItems: 'center',
            height: 30,
            justifyContent: 'center',
            width: 30,
            margin: 0,
            color: theme.palette.text.primary,
            fontSize: 12,

            // Day outside of the current month
            '&.react-datepicker__day--outside-month': {
              color: theme.palette.grey[500],
            },

            // Hover state
            '&:hover': {
              backgroundColor: theme.palette.primary.main,
              borderRadius: '50%',
              color: '#FFF',
              fontWeight: 400,
            },

            // Selected day
            '&.react-datepicker__day--selected, &.react-datepicker__day--keyboard-selected': {
              backgroundColor: theme.palette.primary.main,
              borderRadius: '50%',
              fontWeight: 400,
              color: '#fff',
            },

            // Today's date
            '&.react-datepicker__day--today': {
              border: `1px solid ${theme.palette.success.main}`, // Changed color for better visibility
              borderRadius: '50%',
              fontWeight: 500,
            },
          },
        },
      },

      // --- D. Time Picker Styles ---

      '& .react-datepicker__time-container': {
        borderLeft: `1px solid ${theme.palette.divider}`, // Use theme divider color
        width: 110,

        '& .react-datepicker__header--time': {
          backgroundColor: theme.palette.primary.main,
          border: 0,
          borderRadius: 0,

          '& .react-datepicker-time__header': {
            color: theme.palette.common.white,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(14),
            textTransform: 'capitalize',
            fontWeight: 500,
          },
        },

        '& .react-datepicker__time-list': {
          '& .react-datepicker__time-list-item': {
            alignItems: 'center',
            boxSizing: 'border-box',
            color: theme.palette.text.primary,
            display: 'flex',
            fontSize: 13,
            justifyContent: 'center',
            height: 32,

            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },

            // Selected time
            '&.react-datepicker__time-list-item--selected': {
              backgroundColor: theme.palette.action.selected, // Use selected color
              color: theme.palette.text.primary,
              fontWeight: 400,
            },
          },
        },
      },
    },
  },

  // --- E. Removed/Consolidated Styles ---

  // Removed unused/incorrect styles: '.MuiDateCalendar-root', '.react-datepicker__tab-loop',
  // '.react-datepicker__close-icon' (requires different approach if using custom input),
  // and the placeholder 'datepicker' and 'datepickerStyle' objects.
}));

export default DatePickerWrapper;
